import { LinkButton } from '@/components/common';
import { Page } from '@/components/dashboard/page';
import { createFileRoute } from '@tanstack/react-router';
import { Button, Code, Heading } from 'ht-sdk/react';
import { api } from '@/api';
import { Download, Pencil } from 'lucide-react';
import type { GamePreset } from '@shared/modelTypes/game-preset-types';
import { toast } from 'sonner';
import { useState } from 'react';

export const Route = createFileRoute('/dashboard/settings/')({
	component: RouteComponent,
	loader: async () => {
		// TODO: fix types so you don't need to pass an empty object
		const gamePresets = await api.gamePresetList({});
		return {
			gamePresets: gamePresets.success ? gamePresets.data : [],
		};
	},
});

function RouteComponent() {
	const data = Route.useLoaderData();
	const [pdfLoading, setPdfLoading] = useState(false);

	return (
		<Page>
			<div className="flex flex-row items-center gap-3">
				<Heading>Settings</Heading>
			</div>

			<div className="flex flex-col gap-1 pb-8">
				<div className="flex w-fit gap-1 rounded-xl border border-gray-200 bg-white p-4">
					{data.gamePresets.map((preset: GamePreset) => (
						<div key={preset.id} className="flex flex-col gap-2">
							<Heading mode="tertiary">Connection Codes</Heading>
							<div className="flex flex-wrap gap-2">
								{preset.connectionCodes.map((code) => (
									<Code key={code} className="text-xs">
										{code}
									</Code>
								))}
							</div>
							<Heading mode="tertiary">Bonus Codes</Heading>
							<div className="flex flex-wrap gap-2">
								{preset.bonusCodes.map((code) => (
									<Code key={code} className="text-xs">
										{code}
									</Code>
								))}
							</div>
							<LinkButton iconLeft={Pencil} to={`/dashboard/settings/${preset.id}`}>
								Edit Codes
							</LinkButton>
						</div>
					))}
				</div>
				<div className="flex w-fit gap-1 rounded-xl border border-gray-200 bg-white p-4">
					{data.gamePresets.map((preset: GamePreset) => (
						<div key={preset.id} className="flex flex-col gap-2">
							<Heading mode="tertiary">Exports</Heading>
							<Button
								iconLeft={Download}
								onClick={async () => {
									setPdfLoading(true);
									const res = await api.generateGameExport({});

									if (res.success) {
										const path = res.data;

										const url = new URL(path, window.location.origin);
										const link = document.createElement('a');

										link.href = url.toString();
										link.download = path.split('/').pop() || 'download';
										document.body.appendChild(link);
										link.click();
										document.body.removeChild(link);
									} else {
										toast.error('Unable to create export');
									}

									setPdfLoading(false);
								}}
								className="cursor-pointer"
								disabled={pdfLoading}
							>
								All Game Components
							</Button>
						</div>
					))}
				</div>
			</div>
		</Page>
	);
}
